import React from "react";
import Select from "react-select";

function SyslogTransportField({ transports = [], value, onChange }) {

    const handleChange = async (selectedOption) => {
        onChange(selectedOption ? selectedOption.value : '');
    }

    const options = Object.keys(transports).map((key) => ({
        value: key,
        label: transports[key]
    }));

    return (
        <div className="oct_settings-field">
            <label className="oct_settings-label">PROTOCOL</label>
            <Select
                id="transport"
                className="oct_selectsearch-v2"
                classNamePrefix="oct-selectsearchsub-v2"
                value={value ? options.find(option => option.value === String(value)) || null : null}
                onChange={handleChange}
                options={options}
                isSearchable={false}
                placeholder="Choose"
                isClearable
            />
        </div>
    );
}

export default SyslogTransportField;
